import { Route } from "@angular/router";
import { lmwBaseRoutes } from './route-locales/lmw-base-routes';
import { AppComponent } from "../app.component";
import { BrowseSubjectsComponent } from "../components/browse-subjects/browse-subjects.component";
import { CaseStudyComponent } from "../components/case-study/case-study.component";
import { BrowseTopicsComponent } from "../components/browse-topics/browse-topics.component";
import { ReportAnIssueComponent } from '../components/report-an-issue/report-an-issue.component';
import { CookiesComponent } from "../components/cookies/cookies.component";
import { HelpComponent } from "../components/help/help.component";
import { MyLearningHomeComponent } from "../components/my-learning/my-learning-home/my-learning-home.component";
import { HomeComponent } from "../components/home/home.component";
import { PrivacyComponent } from "../components/privacy/privacy.component";
import { TermsAndConditionsComponent } from "../components/terms-and-conditions/terms-and-conditions.component";
import { AccessibilityComponent } from "../components/accessibility/accessibility.component";
import { TopicLandingComponent } from "../components/topic-landing/topic-landing.component";
import { LocaleResolver } from "../services/locale.resolver";
import { TopicsResolver } from '../services/topics.resolver'
import { SubjectImageResolver } from '../services/subject-image.resolver'
import { TopicResolver } from "../services/topic.resolver";
import { StrapiResolver, StrapiRoute } from "@nx/strapi";
import { SubjectsResolver } from "../services/subjects.resolver";
import { MyLearningResolver } from "../services/my-learning.resolver";
import { UserSignedInResolver } from "../services/user-signed-in.resolver";
import { UserClaimsResolver } from "@nx/auth";
import { environment } from "apps/learn-my-way/src/environments/environment";
import { BreadcrumbAndNavigationComponent } from "../components/breadcrumb-and-navigation/breadcrumb-and-navigation.component";
import { MyLearningRouteGuard } from './my-learning-route.guard';
import { editMyDetailsRoutes } from "../../edit-my-details/routing/route-locales/edit-my-details-routes";
import { SubjectResolver } from "../services/subject.resolver";

export const lmwHomeState: StrapiRoute = {
  path: lmwBaseRoutes.lmwHomeStatePath,
  pathMatch: 'full',
  data: {
    title: lmwBaseRoutes.lmwHomeStateTitle,
    strapiUrl: "home?populate[homeFirstSection][populate]=*&populate[homeSecondSection][populate]=*&populate[homeThirdSection][populate]=*"
  },
  component: HomeComponent,
  resolve: {
    userSignedIn: UserSignedInResolver,
    cmsData: StrapiResolver
  }
}

export const browseSubjectsState: StrapiRoute = {
  path: lmwBaseRoutes.browseSubjectsStatePath,
  component: BrowseSubjectsComponent,
  data: {
    title: lmwBaseRoutes.browseSubjectsTitle,
    strapiUrl: "browse-subjects"
  },
  resolve: {
    userSignedIn: UserSignedInResolver,
    subjects: SubjectsResolver,
    cmsData: StrapiResolver
  }
}

export const myLearningHomeState: StrapiRoute = {
  path: lmwBaseRoutes.myLearningHomeStatePath,
  component: MyLearningHomeComponent,
  canActivate: [MyLearningRouteGuard],
  data: {
    title: lmwBaseRoutes.myLearningHomeTitle,
    strapiUrl: "my-learning"
  },
  resolve: {
    userSignedIn: UserSignedInResolver,
    subjects: MyLearningResolver,
    userClaims: UserClaimsResolver,
    cmsData: StrapiResolver
  }
}

export const caseStudyState: StrapiRoute = {
  path: lmwBaseRoutes.caseStudyStatePath,
  component: CaseStudyComponent,
  data: {
    title: lmwBaseRoutes.caseStudyTitle,
    strapiUrl: "case-study?populate[caseStudyFirstSection][populate]=*&populate[caseStudySecondSection][populate]=*"
  },
  resolve: {
    localeId: LocaleResolver,
    cmsData: StrapiResolver
  }
}

export const helpState: StrapiRoute = {
  path: lmwBaseRoutes.helpStatePath,
  component: HelpComponent,
  data: {
    title: lmwBaseRoutes.helpTitle,
    strapiUrl: "help?populate[0]=helpDesktop&populate[1]=helpDesktop.helpInstructions&populate[2]=helpDesktop.helpInstructions.image&populate[3]=helpMobile&populate[4]=helpMobile.helpInstructions&populate[5]=helpMobile.helpInstructions.image&populate[6]=helpSecondSection&populate[7]=accordionHelpCallout"
  },
  resolve: {
    userSignedIn: UserSignedInResolver,
    localeId: LocaleResolver,
    cmsData: StrapiResolver
  }
}

export const browseTopicsState: StrapiRoute = {
  path: `${lmwBaseRoutes.browseSubjectsStatePath}/:subject-slug`,
  component: BrowseTopicsComponent,
  data: {
    title: lmwBaseRoutes.browseTopicsTitle,
    strapiUrl: "browse-topics"
  },
  resolve: {
    userSignedIn: UserSignedInResolver,
    subject: SubjectResolver,
    topics : TopicsResolver,
    cmsData: StrapiResolver
  }
}

export const topicLandingState: StrapiRoute = {
  path: `${lmwBaseRoutes.browseSubjectsStatePath}/:subject-slug/:topic-slug`,
  component: TopicLandingComponent,
  data: {
    title: lmwBaseRoutes.topicLandingTitle,
    strapiUrl: "topic-landing"
  },
  resolve: {
    userSignedIn: UserSignedInResolver,
    localeId: LocaleResolver,
    subjectImageNumber : SubjectImageResolver,
    topic : TopicResolver,
    cmsData: StrapiResolver
  }
}

export const termsAndConditionsState: StrapiRoute = {
  path: lmwBaseRoutes.termsAndConditionsStatePath,
  data: {
    title: lmwBaseRoutes.termsAndConditionsTitle,
    strapiUrl: "terms-and-condition"
  },
  component: TermsAndConditionsComponent,
  resolve: {
    cmsData: StrapiResolver
  }
}

export const accessibilityState: Route = {
  path: lmwBaseRoutes.accessibilityStatePath,
  data: {
    title: lmwBaseRoutes.accessibilityTitle,
    strapiUrl: "accessibility"
  },
  component: AccessibilityComponent,
  resolve: {
    cmsData: StrapiResolver
  }
}

export const reportAnIssueState: StrapiRoute = {
  path: lmwBaseRoutes.reportAnIssueStatePath,
  data: {
    title: lmwBaseRoutes.reportAnIssueTitle,
    strapiUrl: "local-support-page?populate[signedOutForm][populate]=*&populate[signedInForm][populate]=*&populate[enquiryFormResponse][populate]=*"
  },
  component: ReportAnIssueComponent,
  resolve: {
    userSignedIn: UserSignedInResolver,
    userClaims: UserClaimsResolver,
    cmsData: StrapiResolver
  }
}

export const cookiesState: StrapiRoute = {
  path: lmwBaseRoutes.cookiesStatePath,
  data: {
    title: lmwBaseRoutes.cookiesTitle,
    strapiUrl: "cookie"
  },
  component: CookiesComponent,
  resolve: {
    cmsData: StrapiResolver
  }
}

export const privacyState: StrapiRoute = {
  path: lmwBaseRoutes.privacyStatePath,
  data: {
    title: lmwBaseRoutes.privacyTitle,
    strapiUrl: "privacy"
  },
  component: PrivacyComponent,
  resolve: {
    cmsData: StrapiResolver
  }
}

export const breadcrumbAndNavigationState: Route = {
  path: '',
  component: BreadcrumbAndNavigationComponent,
  children: [
    browseSubjectsState,
    caseStudyState,
    myLearningHomeState,
    {
      path: editMyDetailsRoutes.editMyDetailsStatePath,
      loadChildren: () => import("../../edit-my-details/edit-my-details.module").then(mod => mod.EditMyDetailsModule)
    },
    helpState,
    browseTopicsState,
    environment.loadLocalSupport ? reportAnIssueState : null,
    environment.loadCookies ? cookiesState : null,
    privacyState,
    termsAndConditionsState,
    accessibilityState,
    topicLandingState
  ].filter(Boolean)
}


export const lmwBaseRootState: Route = {
  path: '',
  component: AppComponent,
  children: [
    lmwHomeState,
    breadcrumbAndNavigationState,
    {
      path: '',
      loadChildren: () => import("../../lmw-error/lmw-error.module").then(mod => mod.LmwErrorModule)
    }
  ]
}

export const LmwBaseStates = [lmwBaseRootState]